import React from 'react'
import PropTypes from 'prop-types'

const RuleChecklist = ({ rules }) => rules.map((rule, i) => <RuleChecklistItem key={i} {...rule} />)

const RuleChecklistItem = ({ name, isValid }) => (
  <div className="col-12 mt-1">
    <div className="row align-items-center h-100">
      <div className={`col-auto px-0 dot radius-circle ${isValid ? 'bg-success' : 'bg-ui-3'}`} />
      <div className="col">
        <p className="txt-subtitle">
          <span className="hide-absolute">{`${isValid ? 'Concluído: ' : 'Pendente: '} ${name}`}</span>
          <span aria-hidden="true">{name}</span>
        </p>
      </div>
    </div>
  </div>
)

RuleChecklistItem.propTypes = {
  name: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired
}

export { RuleChecklistItem }
export default RuleChecklist
